document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".splide.blog-listing-carousel").forEach((carousel) => {
      let slides = carousel.querySelectorAll(".splide__slide");
      let slidesCount = slides ? slides.length : 0; 
      let prevArrow = carousel.querySelector(".splide__arrow--prev");
      let nextArrow = carousel.querySelector(".splide__arrow--next");

      
      function updateArrowVisibility() {
          if (prevArrow && nextArrow) {
              if (slidesCount <= 3) {
                  prevArrow.style.display = "none";
                  nextArrow.style.display = "none";
              } else {
                  prevArrow.style.display = "";
                  nextArrow.style.display = "";
              }
          }
      }

      
      let splide = new Splide(carousel, {
          type: slidesCount > 3 ? "loop" : "slide", 
          perPage: 3,
          gap: "20px",
          autoplay: false,
          interval: 3000,
          arrows: slidesCount > 3, 
          pagination: false,
          breakpoints: {
              1024: { perPage: 2 },
              768: { perPage: 1.5, focus: 'center' }
            }
      });

     
      splide.on("mounted", function () {
          updateArrowVisibility();
      });

      
      let progressBar = carousel.querySelector(".progress-bar .progress-fill");
      if (progressBar) {
          splide.on("mounted move", function () {
              let totalSlides = splide.length;
              let currentIndex = splide.index + 1;
              let progress = (currentIndex / totalSlides) * 100;

              if (window.innerWidth >= 1024) {
                  progress = (currentIndex / totalSlides) * 200;
              }

              if (totalSlides === 3 && window.innerWidth >= 1024) progress = 100;
              if (totalSlides === 3 && window.innerWidth < 1024 && window.innerWidth > 768) {
                  progress = (currentIndex / totalSlides) * 200;
              }

              progressBar.style.width = progress + "%";
          });
      }

      splide.mount();
  });
});
